var map = {
	"./account/login": 474,
	"./account/login.tsx": 474,
	"./account/register": 172,
	"./account/register.tsx": 172,
	"./discover": 375,
	"./discover.tsx": 375,
	"./home": 54,
	"./home.tsx": 54,
	"./message": 7223,
	"./message.tsx": 7223,
	"./message/[id]": 7397,
	"./message/[id].tsx": 7397,
	"./notify": 5108,
	"./notify.tsx": 5108,
	"./post/[id]": 8510,
	"./post/[id].tsx": 8510,
	"./profile/[id]": 7687,
	"./profile/[id].tsx": 7687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2150;